import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { emptyOnForbidden, supportQueryRetry } from '../../utils/Support/supportHelpers';
import { SUPPORT_PATHS, SUPPORT_QUERY_KEYS, unwrapValues } from './supportQueryHelpers';

export interface IAvailableUser {
	id: string;
	name: string;
	email: string;
	profilePic?: string;
}

/**
 * Search for users that can be added as support agents for a mailbox.
 * Enabled when query is at least 2 characters.
 */
export function useAvailableUsersQuery(mailboxId: string, query: string) {
	const userSession = useUserSession();
	const trimmedQuery = query.trim();

	return useQuery({
		queryKey: SUPPORT_QUERY_KEYS.mailboxes.availableUsers(mailboxId, trimmedQuery),
		retry: supportQueryRetry,
		queryFn: () =>
			emptyOnForbidden<IAvailableUser[]>(async () => {
				const response = await userSession.webServiceHelper.callAsync<IAvailableUser[] | { values?: IAvailableUser[] }>(
					SUPPORT_PATHS.mailboxes.availableUsers(mailboxId, trimmedQuery),
					'GET'
				);
				return unwrapValues(response);
			}, []),
		enabled: !!mailboxId && trimmedQuery.length >= 2,
		staleTime: 10_000,
		meta: { toastErrorMessage: 'Failed to load available users' },
	});
}
